export const getTimezoneOffset = (timezoneName?: string) => {
  return (
    new Date()
      .toLocaleDateString('en-US', {
        day: '2-digit',
        timeZone: timezoneName,
        timeZoneName: 'short',
      })
      // toLocaleDateString in this case returns a string like "01, GMT+1"
      // so slicing the first 4 symbols gets us the offset
      .slice(4)
  );
};
